import { render, staticRenderFns } from "./AddPep.vue?vue&type=template&id=4ebd5ae4&scoped=true&"
import script from "./AddPep.vue?vue&type=script&lang=js&"
export * from "./AddPep.vue?vue&type=script&lang=js&"
import style0 from "./AddPep.vue?vue&type=style&index=0&id=4ebd5ae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd5ae4",
  null
  
)

export default component.exports